import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { SessionMgmtService } from 'src/app/shared/services/session-mgmt/session-mgmt.service';
import * as _ from 'lodash';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { Subscription } from 'rxjs';
import { ManagersService } from 'src/app/shared/services/managers/managers.service';
import { TableService } from 'src/app/shared/services/table/table.service';
import { getDeviationTooltipText, getPositiveDeviationValue, shouldShowDeviation } from 'src/app/shared/utils/score-deviation.util';
import {
  applyScoreHoverTitlePopperOptions,
  getScoreHoverTitle,
  SCORE_HOVER_TITLE_PLACEMENT,
  SCORE_HOVER_TITLE_TOOLTIP_CLASS,
} from 'src/app/shared/utils/hover-title.helper';
import { NgStyle, NgFor, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { ScoreDropdownMenuComponent } from '../score-dropdown-menu/score-dropdown-menu.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-score-table',
    templateUrl: './score-table.component.html',
    styleUrls: ['./score-table.component.scss'],
    imports: [
        NgStyle,
        NgFor,
        NgClass,
        NgIf,
        ScoreDropdownMenuComponent,
        NgTemplateOutlet,
        LtmsLoaderComponent,
        NgbTooltip,
    ]
})

export class ScoreTableComponent implements OnChanges {
  @Input('isFullTableLoadingSet')
  set isFullTableLoadingSet(value) {
    this.isFullTableLoading = value;
  }
  isFullTableLoading: boolean = false;
  shouldApplyStickyColumnStyle: boolean = true;
  @Input() tablePlugins: any = {
    isTableResize: false
  }
  @Input() tableColumns: any = [];
  @Input() tableId: string = 'Parent';
  @Input() sortedTableId: any = null;
  @Input() tableData: any = [];
  @Input() tableFooter: any = [];
  @Input() searchText: string = '';
  @Input() isChildData: boolean = false;
  @Input() showDeviation: boolean = false;
  @Input() deviationComparisonLabel: string = '';
  @Input() selectedRowHighlight: boolean = false;
  @Input() selectedRowId: any = '';
  @Input() isMaximized: boolean = false;
  @Input() isTrendsTable: boolean = false;
  filteredTableData: any[] = [];
  @Output() removeSort:any = new EventEmitter<any>()
  private subscriptions: Subscription = new Subscription();
  sortActiveTableId:any = null
  ids = ['passives_per', 'promoters_per', 'detractors_per'];
  constructor(
    private router: Router, 
    private helpersService: HelpersService,
    private _sessionMgmtService: SessionMgmtService,
    private responseAnalyticsService: ResponseAnalyticsService,
    private _managersService: ManagersService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(this.sortedTableId != this.tableId){
      this.blinkColumn = null
      this.sortColumn = null;
    }
    if (changes['tableData']) {
      this.filteredTableData = this.tableData;
      this.sortColumn = null;
      this.sortDirection = 'asc';
      this.blinkColumn = null;
    }
    if(changes['searchText']) {
      this.searchQuery = this.searchText;
      this.onSearch();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // Searching in table code start from here
  searchQuery: string = '';
  searchColumns: string[] = ['name'];

  onSearch() {
    if (this.searchQuery.trim() === '') {
     this.filteredTableData = [...this.tableData];
    } else {
     const queryLower = this.searchQuery.toLowerCase();
     this.filteredTableData = this.tableData.filter(row => {
        return this.searchColumns.some(columnId => {
         const cellValue = row[columnId];
         if (cellValue) {
            return String(cellValue).toLowerCase().includes(queryLower);
         }
         return false;
        });
     });
    }
    if(this.tableColumns && this.tableColumns.length > 0 && this.tableColumns[0]?.isDropdown) {
     let dummyRow: any = [];
     if(this.filteredTableData && this.filteredTableData.length > 0) {
        let data = this.filteredTableData[0];
        const lengthOfRowData: any = (7 - this.filteredTableData.length);
        for(let i = 0; i < lengthOfRowData; i++) {
         let obj: any = {};
         for (let key in data) {
            if (data.hasOwnProperty(key)) {
             obj['blank'] = 'no data available, blank row';
            }
         }
         dummyRow.push(obj);
        }
     }
     this.filteredTableData = [...this.filteredTableData, ...dummyRow];
    }
}
  // Searching in table code end here

  // Resize table column code start from here
  isResizing = false;
  currentColumnIndex: number | null = null;
  startX: number = 0;
  startWidth: number = 0;
  minWidth: any = {};
  resizeColumn: string | null = null;

  onMouseDown(event: MouseEvent, index: number) {
    this.isResizing = true;
    this.currentColumnIndex = index;
    this.startX = event.pageX;
    const target = event.target as HTMLElement;
    if (target && target.parentNode) {
      this.startWidth = target.parentNode['offsetWidth'];
    }
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isResizing && this.currentColumnIndex !== null) {
      this.resizeColumn = this.tableColumns[this.currentColumnIndex].uniqueId;
      if(!(this.tableColumns[this.currentColumnIndex].uniqueId in this.minWidth)) {
        this.minWidth[this.tableColumns[this.currentColumnIndex].uniqueId] = parseInt(this.tableColumns[this.currentColumnIndex].width, 10); 
      }
      const newWidth = this.startWidth + (event.pageX - this.startX);
      if(newWidth > this.minWidth[this.tableColumns[this.currentColumnIndex].uniqueId]) {
        this.tableColumns[this.currentColumnIndex].width = `${Math.max(newWidth)}px`;
      }
    }
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isResizing = false;
    this.currentColumnIndex = null;
    this.resizeColumn = null;
  }
  // Resize table column code end here

  // Sort table column code start from here 
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';
  blinkColumn: string | null = null;

  getSortIcon(column: any): string {
    if (this.sortColumn === column.uniqueId) {
      return this.sortDirection === 'asc' ? 'assets/images/arrow-up.svg' : 'assets/images/arrow.svg';
    }
    return 'assets/images/arrow-up.svg';
  }

  onSort(column: any) {
    if (this.sortColumn === column.uniqueId) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column.uniqueId;
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.blinkColumn = column.uniqueId;
    this.sortActiveTableId = this.tableId
    this.sortData();
    this.removeSort.emit(this.tableId)
  }

  disableSorting(event:any){
    this.sortActiveTableId = event
    if(event != this.tableId){
      this.blinkColumn = null
      this.sortColumn = null;
    }
    this.removeSort.emit(event)
  }

  sortData() {
    if (this.sortColumn) {
     // Separate real rows and dummy rows (empty rows)
     const realRows = this.filteredTableData.filter(row => !row.blank);
     const dummyRows = this.filteredTableData.filter(row => row.blank);

     // Separate original data into two buckets: sortable and non-sortable (N/A)
     const columnId = this.sortColumn!;
     const sortableRows: any = [];
     const nonSortableRows: any = [];

     for (const row of realRows) {
        const value = this.getSortableValue(row[columnId]);
        // Mark as non-sortable if value is N/A, empty, null, or similar
        if (
         value === "" ||
         value === null ||
         value === undefined ||
         row[columnId]?.toString().trim().toLowerCase() === "n/a"
        ) {
         nonSortableRows.push(row); // maintain original order
        } else {
         sortableRows.push(row);
        }
     }


     // Sort real rows
     sortableRows.sort((a, b) => {
        const valA = this.getSortableValue(a[this.sortColumn!]);
        const valB = this.getSortableValue(b[this.sortColumn!]);

        if (this.sortDirection === 'asc') {
         return this.compareValues(valA, valB);
        } else {
         return this.compareValues(valB, valA);
        }
     });

     // If rows have childRow arrays, sort them too
     sortableRows.forEach(row => {
        if (Array.isArray(row.childRow) && row.childRow.length > 0) {
         row.childRow.sort((a, b) => {
            const valA = this.getSortableValue(a[this.sortColumn!]);
            const valB = this.getSortableValue(b[this.sortColumn!]);
            if (this.sortDirection === 'asc') {
             return this.compareValues(valA, valB);
            } else {
             return this.compareValues(valB, valA);
            }
         });
        }
     });

     // Concatenate sorted + untouched N/A rows + dummy rows
     this.filteredTableData = [...sortableRows, ...nonSortableRows, ...dummyRows];
    } else {
     return;
    }
  }

  getSortableValue(value: any): any {
    if (value == null || value === "") return "";
    value = String(value).trim();
    // Ensure N/A is treated as non-sortable
    if (value.toLowerCase() === "n/a") return "";
    value = value.replace(/,/g, "");
    const match = value.match(/^[-]?\d+(\.\d+)?|^[a-zA-Z ]*\d+(\.\d+)?|^[a-zA-Z0-9 ]+/);
    if (!match) return "";
    const extracted = match[0].trim();
    const num = Number(extracted);
    return !isNaN(num) && extracted !== "" ? num : extracted;
  }

  compareValues(valA: any, valB: any): number {
    if (typeof valA === 'number' && typeof valB === 'number') {
      return valA - valB;
    }
    if (typeof valA === 'string' && typeof valB === 'string') {
      return valA.localeCompare(valB);
    }
    if (typeof valA === 'number' && typeof valB === 'string') {
      return -1;
    }
    if (typeof valA === 'string' && typeof valB === 'number') {
      return 1;
    }
    return 0;
  }
  // Sort table column code end here

  // Redirect to project start from here
  accountId: string = '';
  recentVisitList: any[] = [];

  redirectToProject(event: any): void {
    if (this.helpersService.helpers['accountDetails']) {
      this.accountId = this.helpersService.helpers['accountDetails']['_id'];
      this._managersService.setCurrentLoggedInManager(this.accountId, event?.projectId).subscribe((reponse: any) => {
        if (this.helpersService.helpers['managerDetails']['last_synced_details']) {
          delete this.helpersService.helpers['managerDetails']['last_synced_details'];
          window['Helpers'] = this.helpersService.consoleData();
        }
        this.router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
          queryParams: {
            account_id: this.accountId,
            project_id: event?.projectId
          }
        });
      });
    } else {
      const helpersSubscription = this.helpersService.appState.subscribe(response => {
        this.accountId = response?.accountDetails?._id;
        this._managersService.setCurrentLoggedInManager(this.accountId, event?.projectId).subscribe((reponse: any) => {
          if (this.helpersService.helpers['managerDetails']['last_synced_details']) {
            delete this.helpersService.helpers['managerDetails']['last_synced_details'];
            window['Helpers'] = this.helpersService.consoleData();
          }
          this.router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
            queryParams: {
              account_id: this.accountId,
              project_id: event?.projectId
            }
          });
        })
      })
      this.subscriptions.add(helpersSubscription);
    }
  }

  // Redirect to project end here

  // Child table row code start from here
  expandedRows = new Set<any>();

  onChildrenRow(row: any): void {
    if (this.expandedRows.has(row)) {
      this.expandedRows.delete(row);
    } else {
      this.expandedRows.add(row);
    }
  }

  isExpandedRow(row: any): boolean {
    return this.expandedRows.has(row);
  }
  // Child table row code end here

  // Drilldown table code start from here
  expandedDrilldownRows = new Set<any>();
  @Output() onDrillDownClick = new EventEmitter<string>();
  onDrilldown(row: any, rows?: any): void {
    this.onDrillDownClick.emit(row);
    if (!row.isExpanded) {
      row.isLoading = true
    }
    if (rows && rows.length) {
      rows = _.map(rows, (rowData) =>{
        if (rowData.key == row.key) {
          if (rowData.isExpanded) {
            rowData.isExpanded = false
            rowData.drillDown = [];
          }else {
            rowData.isExpanded = true
          }
        } else {
          rowData.isExpanded = false
          rowData.drillDown = [];
        }
        return rowData;
      })      
    }
    // if (this.expandedDrilldownRows.has(row)) {
    //   this.expandedDrilldownRows.delete(row);
    //   this.collapseChildren(row);
    // } else {
    //   this.expandedDrilldownRows.add(row);
    // }
  }

  isExpanded(row: any): boolean {
    // return this.expandedDrilldownRows.has(row);
    if (row && row.isExpanded) {
      return row.isExpanded;
    } else {
      return false
    }
  }

  collapseChildren(row: any) {
    if (row.drillDown && row.drillDown.length) {
      row.drillDown.forEach(child => {
        this.expandedDrilldownRows.delete(child);
        if (child.drillDown) {
          this.collapseChildren(child);
        }
      });
    }
  }

  getColor(row: any, column: any) {
    if(column && (this.ids.indexOf(column.uniqueId) != -1)){
      if(row && row[column.uniqueId + '_color']) {
        return {'color': row[column.uniqueId + '_color'], 'font-weight': 700, 'font': column?.style?.font};
      }
    }
    return;
  }
  ifQuickInsightNPS(column: any) {
    if(column && (this.ids.indexOf(column.uniqueId) != -1)){
      return true;
    }
    return false;
  }
  // Drilldown table code end here 

  // Drilldown table sort code start from here
  // ----------- Remaining---------------- 
  // Drilldown table sort code end here

  // Table badge code start from here
  getBadgeClass(value: string): string {
    switch (value) {
      case 'In setup':
        return 'inSetup';
      case 'Closed':
        return 'closed';
      case 'On hold':
        return 'onHold';
      case 'Live':
        return 'live';
      default:
        return '';
    }
  }
  // Table badge code end here

  // Dropdown code start from here
  @Output() tableDropdownOptionChange = new EventEmitter<string>();

  onOptionChange(event: any): void {
    this.tableDropdownOptionChange.emit(event);
  }
  // Drop code end here

  // On click event code start from here
  @Output() onTextClickCall = new EventEmitter<string>();
  onTextClick(row: any): void {
    this.onTextClickCall.emit(row);
  }
  // On click event code end here

  checkIsNaN(value) {
    return isNaN(value)
  }
  numberFormatting(value) {
    return Helpers.INRCurrencyPipeFilter(value);
  }

  readonly hoverTitleTooltipClass = SCORE_HOVER_TITLE_TOOLTIP_CLASS;
  readonly hoverTitlePlacement = SCORE_HOVER_TITLE_PLACEMENT;
  readonly hoverTitlePopperOptions = applyScoreHoverTitlePopperOptions;

  title(value: unknown): string | null {
    return getScoreHoverTitle(value);
  }

  getDeviationTooltip(deviation: any): string {
    return getDeviationTooltipText(deviation, this.deviationComparisonLabel);
  }

  shouldShowDeviation = shouldShowDeviation;
  getPositiveDeviationValue = getPositiveDeviationValue;

  private readonly deviationAlignmentExcludedColumns = new Set([
    'name',
    'toppercent',
    'midpercent',
    'bottompercent',
  ]);

  isDeviationAlignedColumn(column: any): boolean {
    const columnId = column?.uniqueId;
    if (columnId == null || this.deviationAlignmentExcludedColumns.has(columnId)) {
      return false;
    }
    if (this.tablePlugins?.alignAllDeviationColumns) {
      return true;
    }
    return columnId === 'rating' || columnId === 'responses';
  }

  usesDeviationAlignment(column: any): boolean {
    return !!(this.tablePlugins?.deviationAlignment && this.showDeviation && this.isDeviationAlignedColumn(column));
  }

  getTruncateMaxWidth(columnIndex: number, fallbackWidth?: string): string | null {
    if (this.isTrendsTable && columnIndex === 0) {
      return '100%';
    }
    return fallbackWidth ?? null;
  }

  getColumnWidth(column: any, columnIndex: number): string | null {
    if (this.isTrendsTable && this.isMaximized) {
      if (columnIndex === 0) {
        return '300px';
      }
      if (columnIndex === 1) {
        return '110px';
      }
    }
    return column?.width ?? null;
  }
}